// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

// import actions
import * as userActions from '../../user/userActions';

// import page components
import ContactUsForm from '../components/ContactUsForm.js.jsx';
import StudyLayout from '../../study/components/StudyLayout.js.jsx';

class Landing extends Base {
  constructor(props, context) {
    super(props);
    this.state = {
      contactUs: {
        email: props.currentUser.username || ''
        , message: ''
        , name: props.currentUser.firstName + ' ' + props.currentUser.lastName || ''
        , subject: ''
      }
      , errors: null
      , isSending: false
      , successMessage: null
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_handleCancel'
    )
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newContactUsState = _.update(this.state.contactUs, e.target.name, function () {
      return e.target.value;
    });
    this.setState({ contactUs: newContactUsState });
  }


  _handleFormSubmit(e) {
    const { currentUser, dispatch, history } = this.props;
    e.preventDefault();
    this.setState({
      isSending: true
    });
    dispatch(userActions.sendContactUsForm(this.state.contactUs)).then((action) => {
      if (action.success) {
        this.setState({
          contactUs: {
            email: currentUser.username || ''
            , message: ''
            , name: currentUser.firstName + ' ' + currentUser.lastName || ''
            , subject: ''
          }
          , errors: null
          , isSending: false
          , successMessage: action.error
        });
      } else {
        // console.log("Response Error:");
        // console.log(action);
        // alert("ERROR - Check logs");
        this.setState({
          errors: action.error
          , isSending: false
          , successMessage: null
        });
      }
    });
  }

  _handleCancel(e) {
    e.preventDefault();
    const agendaUrl = `${window.agendaUrl}/agenda`;
    window.location.href = agendaUrl;
  }

  render() {
    const { contactUs, errors, isSending, successMessage } = this.state;
    return (
      <StudyLayout>
        <Helmet
          title={"Contact Us | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Contact Support Form </h1>
              <hr />
              {isSending ?
                <div className="u-centerText">
                  <div className="loading"></div>
                </div>
                :
                <ContactUsForm
                  handleCancel={this._handleCancel}
                  contactUs={contactUs}
                  errors={errors}
                  formTitle={"Contact Support"}
                  handleFormChange={this._handleFormChange}
                  handleFormSubmit={this._handleFormSubmit}
                  successMessage={successMessage}
                />
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}

Landing.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    currentUser: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(Landing)
);



// WEBPACK FOOTER //
// modules/static/views/ContactUs.js.jsx